import { render, staticRenderFns } from "./MewIcon.vue?vue&type=template&id=fea295a2"
import script from "./MewIcon.vue?vue&type=script&lang=js"
export * from "./MewIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports